import logoIcon from "../../assets/pr-logo1.svg"
import mobileherobg from "../../assets/mobileherobg.png"

export const Footer = () => {
  return (
    <footer
      className="mt-40 relative flex flex-col items-center gap-6 pb-16 pt-32"
      style={{
        backgroundImage: `url(${mobileherobg})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <img className="w-[200px] md:w-[280px]" src={logoIcon} alt="Playroom logo" />
      <p className="text-[1.4rem] md:text-[1.6rem] text-textGrey">&copy; {new Date().getFullYear()} Playroom Inc.</p>
      <a
        href="https://joinplayroom.com/games/privacy.txt"
        target="_blank"
        rel="noopener noreferrer"
        className="text-[1.4rem] md:text-[1.6rem] text-textGrey hover:text-white transition-colors"
      >
        Privacy Policy
      </a>
    </footer>
  )
}
